// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"329":"4111ddf7","500":"a2a485fb","513":"8d7a2051","647":"5a720fc4","881":"f35325c2","904":"507a2a43"}[chunkId] + ".chunk.js";
};